import React, { useState } from 'react';
import { View, Text, StyleSheet, Pressable, Platform } from 'react-native';
import { FontAwesome6 } from '@expo/vector-icons';
import { colors, typography } from '../../styles/theme';

interface MenuListItemProps {
  icon: React.ReactNode;
  label: string;
  onPress: () => void;
  isLast?: boolean;
  isCentered?: boolean;
  noChevron?: boolean;
}

export default function MenuListItem({ icon, label, onPress, isLast = false, isCentered = false, noChevron = false }: MenuListItemProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable
      style={({ pressed }) => [
        styles.row, 
        isLast && styles.rowLast,
        isCentered && styles.rowCentered,
        Platform.OS === 'web' && isHovered && styles.rowHover,
        pressed && styles.rowPressed
      ]} 
      onPress={onPress}
      // @ts-ignore - onHoverIn/Out are supported by Pressable but might be missing in some RN types
      onHoverIn={() => setIsHovered(true)}
      // @ts-ignore
      onHoverOut={() => setIsHovered(false)}
    >
      <View style={[styles.left, isCentered && styles.leftCentered]}>
        {icon}
        <Text style={styles.label} numberOfLines={1}>{label}</Text>
      </View>
      {!noChevron && (
        <FontAwesome6 name="chevron-right" size={16} color="#c1c5ce" solid />
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: {
    width: '100%',
    backgroundColor: 'transparent',
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    paddingVertical: 16,
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rowLast: {
    borderBottomWidth: 0,
  },
  rowHover: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  rowPressed: {
    opacity: 0.7,
  },
  rowCentered: {
    justifyContent: 'center',
  },
  leftCentered: {
    justifyContent: 'center',
  },
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  label: {
    ...typography.bodyBold,
    color: colors.text,
    fontSize: 16,
    letterSpacing: 0.3,
  },
});
